module.exports = __webpack_public_path__ + "static/media/banner3.5a7a4686.png";